import { useCallback } from 'react';
import { DatePicker } from 'components/ui';
import { formikOnChangeAdaptorTypes } from 'const/propTypes';
import dayjs from 'dayjs';

export const DatePickerFormik = ({
  onChange,
  name,
  value,
  storageFormat = null,
  ...props
}) => {
  const handleChange = useCallback(
    (newValue) => {
      if (newValue) {
        const formattedValue = storageFormat
          ? newValue.format(storageFormat)
          : newValue.toISOString();
        onChange(name, formattedValue);
      } else {
        onChange(name, null);
      }
    },
    [onChange, name, storageFormat]
  );

  const pickerValue = useCallback(() => {
    if (!value) return null;

    if (storageFormat && value) {
      return dayjs(value, storageFormat);
    }

    return dayjs(value);
  }, [value, storageFormat])();

  return <DatePicker {...props} onChange={handleChange} value={pickerValue} />;
};

DatePickerFormik.propTypes = formikOnChangeAdaptorTypes;
